import { SetLessonSlidesRecordOnlyDocument } from "@/generated/graphql";
import { withToast } from "@/lib/utils/withToast";
import { useMutation } from "@apollo/client/react";

export function useSetLessonSlidesRecordOnly() {
  const [mutate, { loading }] = useMutation(SetLessonSlidesRecordOnlyDocument);

  const setLessonSlidesRecordOnly = async (lessonId: string, recordOnly: boolean) => {
    return withToast(
      async () => {
        const res = await mutate({
          variables: { lessonId, recordOnly },
        });
        return res.data?.setLessonSlidesRecordOnly ?? [];
      },
      {
        loading: recordOnly ? "Enabling record-only..." : "Disabling record-only...",
        success: recordOnly
          ? "Record-only enabled on all supported slides"
          : "Record-only disabled on all supported slides",
        error: "Failed to update slides. Please try again.",
      },
      "setLessonSlidesRecordOnly"
    );
  };

  return { setLessonSlidesRecordOnly, loading };
}
